// import permisob from './permisob';
import permisob_rag from './auto/permisob_rag';
import permisob_add from './permisob_creacion_preguntas';

// NOTE: Tools outside this list may scape permissions
const TOOLS = [permisob_rag, permisob_add];

export default TOOLS;
